import { ComponentProps, FC } from 'react';
import { lighten, Chip as MuiChip } from '@mui/material';
import { Sx } from 'types/Common';
import { SystemColors } from 'melp-design/style';
import { type SvgIconComponent as MuiSvgIconComponent } from '@mui/icons-material';

export const variants = [
  'info',
  'neutral',
  'warning',
  'error',
  'success',
] as const;
type Variant = (typeof variants)[number];

interface Props {
  label: string | number;
  variant?: Variant;
  onClick?: ComponentProps<typeof MuiChip>['onClick'];
  icon?: MuiSvgIconComponent;
}

const STYLES_BY_VARIANT: Record<Variant, Sx> = {
  info: {
    color: SystemColors.white,
    backgroundColor: SystemColors.primary.base,
  },
  neutral: {
    color: SystemColors.black,
    backgroundColor: SystemColors.grey[90],
  },
  warning: {
    color: SystemColors.white,
    backgroundColor: SystemColors.warning.base,
  },
  error: {
    color: SystemColors.white,
    backgroundColor: SystemColors.danger.base,
  },
  success: {
    color: SystemColors.white,
    backgroundColor: SystemColors.success.base,
  },
};

export const Chip: FC<Props> = ({
  label,
  variant = 'info',
  onClick,
  icon: Icon,
}) => {
  return (
    <MuiChip
      label={label}
      onClick={onClick}
      icon={Icon ? <Icon color="inherit" sx={{ fontSize: 16 }} /> : undefined}
      sx={{
        borderRadius: 2,
        height: 24,
        minWidth: 20,
        ...STYLES_BY_VARIANT[variant],

        '> .MuiChip-label': {
          fontSize: 14,
          fontWeight: 500,
          lineHeight: 1,
          p: 1,
        },

        '&:hover': {
          backgroundColor: lighten(
            STYLES_BY_VARIANT[variant].backgroundColor,
            0.3,
          ),
        },
      }}
    />
  );
};
